module.exports = __webpack_public_path__ + "img/numero_1.06a67113.png";